import React from 'react';
import './PageLoadingSkeleton.css';

/**
 * Minimal top-bar progress indicator shown only during
 * React.lazy() chunk download (Suspense fallback).
 * This phase is very short — just needs to signal "something is loading"
 * without faking a layout that doesn't match the actual page.
 */
const PageLoadingSkeleton: React.FC = () => (
  <>
    <style>{`
      @keyframes page-load-slide {
        0%   { transform: translateX(-100%); }
        60%  { transform: translateX(20%); }
        100% { transform: translateX(100%); }
      }
      .page-load-bar {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: #e2e8f0;
        z-index: 9999;
        overflow: hidden;
      }
      .page-load-bar__fill {
        height: 100%;
        width: 40%;
        background: linear-gradient(90deg, #002781, #457EFF);
        border-radius: 0 2px 2px 0;
        animation: page-load-slide 1.2s ease-in-out infinite;
      }
    `}</style>
    <div className="page-load-bar">
      <div className="page-load-bar__fill" />
    </div>
  </>
);

export default PageLoadingSkeleton;
